import { useEffect, useState } from "react";

export default function useOpinion(props: any) {
  // console.log("render Strengths & Weakness")
  
  const { 
    loadingNew,
    radarItemArr,
    radarLabelArr,
    topictabList,
    filterAll
  } = props

  const [language, setLanguage] = useState('0')
  const [selectedTopic, setSelectedTopic] = useState('All Topic')
  
  const RegionlList = [
    { value: "0", text: "Original Language", text_zh: '源语种' },
    { value: "1", text: "English", text_zh: '英文' },
    { value: "2", text: "Chinese", text_zh: '中文'},
  ];

  const getSelectedTopic = (val: string) => {
    setSelectedTopic(val)
  }

  return{
    loadingNew,
    radarItemArr,
    radarLabelArr,
    topictabList,
    filterAll,
    language,
    setLanguage,
    selectedTopic,
    getSelectedTopic,
    RegionlList
  }
}
